// import Parsley from 'parsleyjs';
// import cash from 'cash-dom';

import { initializeFirebase } from './utils.js';

(function($) {
	$(document).ready(function() {

    // Initialize Firebase app with configuration from WordPress
    // Use shared utility function to handle initialization safely
    initializeFirebase('theme.js');

    /**
     * Listens for use of the Tab key and adds a class to the body
     * to indicate that the user is tabbing. If user is tabbing we
     * add a class to the body that will disable the focus ring on
     * buttons and links.
     *
     * @param {object} e - The event object
     */
    function handleFirstTab(e) {
      if (e.keyCode === 9) { // tab key
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
      }
    }
    window.addEventListener('keydown', handleFirstTab);

		// Scroll to top
		var sstButton = $('#ssttbutton'),
	      sstTimeout = false;

	  $(window).on('scroll', function() {
	    clearTimeout(sstTimeout);

	    if ($(this).scrollTop() < 500) {
	      sstButton.fadeOut();
	    } else {
	      sstButton.fadeIn();

	      sstTimeout = setTimeout(function() {
	        $('#ssttbutton') .fadeOut();
	      }, 1000);
	    }
	  });

	  $('#ssttbutton').on('click', function() {
	    $('html, body').animate({scrollTop:0}, 300);
	    return false;
	  });
		// END Scroll to top



		// GA Click Tracking
		if (site.env === 'production' && site.loggedIn !== '1') {
			document.querySelectorAll('.advertisement').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'ad',
						'event_label': this.dataset.adTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'advertisement',
						'click_action': 'ad (link)',
						'click_value': this.dataset.adTitle,
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.patreon-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'patreon',
						'event_label': 'patreon link',
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'patreon',
						'click_action': 'patreon link',
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.advertisement-no-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'ad (no link)',
						'event_label': this.dataset.adTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'advertisement',
						'click_action': 'ad (no link)',
						'click_value': this.dataset.adTitle,
						'send_to': 'GA4'
					});
				});
			});

				const spotifyPlaylist = document.getElementById('spotify-playlist');
				if (spotifyPlaylist) {
					spotifyPlaylist.addEventListener('click', function() {
						gtag('event', 'click', {
							'event_category': 'spotify player',
							'event_label': 'opened spotify player',
							'send_to': 'UA'
						});

						gtag('event', 'click', {
							'click_type': 'spotify player',
							'click_action': 'opened',
							'send_to': 'GA4'
						});
					});
				}

			document.querySelectorAll('.filters-btn.closed').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'filters',
						'event_label': 'filters drawer opened',
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'filters',
						'click_action': 'opened',
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.show-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'shows',
						'event_label': 'show link',
						'event_value': this.dataset.showTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'show_listing',
						'click_action': 'show link',
						'click_value': this.dataset.showTitle,
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.venue-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'shows',
						'event_label': 'venue link',
						'event_value': this.dataset.venueTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'show_listing',
						'click_action': 'venue link',
						'click_value': this.dataset.venueTitle,
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.maps-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'shows',
						'event_label': 'map link',
						'event_value': this.dataset.venueTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'show_listing',
						'click_action': 'map link',
						'click_value': this.dataset.venueTitle,
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.social-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'social',
						'event_label': 'social link',
						'event_value': this.getAttribute('title'),
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'social',
						'click_action': 'social link',
						'click_value': this.getAttribute('title'),
						'send_to': 'GA4'
					});
				});
			});
    }
		// END GA Click Tracking

    /**
     * Triggers a CSS animation on a specified element.
     *
     * @param {string} element - The selector of the element to animate.
     * @param {string} animation - The animation name to apply.
     * @param {string} [prefix='animate__'] - The prefix to use for the animation classes.
     * @returns {Promise} A promise that resolves when the animation ends.
     *
     * @example
     * animateCSS('.my-element', 'fadeIn');
     *
     * @example
     * animateCSS('.my-element', 'bounce').then((message) => {
     *   // Do something after the animation
     * });
     */
    function _animateCSS(element, animation, prefix = 'animate__') {
      // We create a Promise and return it
      new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = document.querySelector(element);

        node.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
          event.stopPropagation();
          node.classList.remove(`${prefix}animated`, animationName);
          resolve('Animation ended');
        }

        node.addEventListener('animationend', handleAnimationEnd, {once: true});
      });
    }

	});
})(jQuery);
